if (!customElements.get("meal-product-card")) {
  customElements.define(
    "meal-product-card",
    class MealProductCard extends HTMLElement {
      constructor() {
        super();
        this.onOpen = this.onOpen.bind(this);
        this.onDialogClick = this.onDialogClick.bind(this);
      }

      connectedCallback() {
        this.openButton = this.querySelector("[data-meal-info-open]");
        this.dialog = this.querySelector("dialog");

        this.openButton?.addEventListener("click", this.onOpen);
        this.dialog?.addEventListener("click", this.onDialogClick);
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener("click", this.onOpen);
        this.dialog?.removeEventListener("click", this.onDialogClick);
      }

      onOpen(event) {
        event.preventDefault();
        if (!this.dialog) return;
        this.dialog.showModal();
      }

      onDialogClick(event) {
        if (!this.dialog) return;
        const closeTarget = event.target.closest("[data-meal-info-close]");
        if (closeTarget) {
          event.preventDefault();
          this.dialog.close();
          return;
        }
        if (event.target === this.dialog) {
          this.dialog.close();
        }
      }
    },
  );
}
